import React, { useEffect, useRef, useState } from 'react'
import "../../Assets/Css/Tickets.scss"
import { useLocation, useNavigate } from 'react-router-dom'
import Select from "react-select";
import { customStyle } from '../../Components/Style';
import ReplyTicket from './ReplyTicket';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import moment from 'moment';
import { updateTicket } from '../../Services/Ticket/action';
import { connect } from 'react-redux';
import { deleteRecord } from '../../Services/Delete/action';
import Swal from 'sweetalert2';
import { FaUserCircle } from 'react-icons/fa';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';
import RoleWiseFeatureWrapper from '../../Lib/RoleWiseFeatureWrapper';
import UserAvatar from 'react-user-avatar';


const priority = [
    { value: 'Urgent', label: 'Urgent' },
    { value: 'High', label: 'High' },
    { value: 'Medium', label: 'Medium' },
    { value: 'Low', label: 'Low' },
]

const channelName = [
    { value: 'Email', label: 'Email' },
    { value: 'Phone', label: 'Phone' },
    { value: 'Twitter', label: 'Twitter' },
    { value: 'Facebook', label: 'Facebook' },
]

const type = [
    { value: 'Suggestion', label: 'Suggestion' },
    { value: 'Question', label: 'Question' },
    { value: 'Sale', label: 'Sale' },
    { value: 'Code', label: 'Code' },
    { value: 'Problem', label: 'Problem' },
    { value: 'Incident', label: 'Incident' },
    { value: 'Management', label: 'Management' },
]

const agent = [

]

function TicketView(props) {
    const location = useLocation();
    const data = location?.state?.data?.allData;
    const [Fields, setFields] = useState({
        priority: priority?.find(item => item?.value == data?.priority),
        channelname: channelName?.find(item => item?.value == data?.channel_name),
        type: type?.find(item => item?.value == data?.type),
        agent: agent?.find(item => item?.value == data?.agent)
    });
    const [tabnav, setTabNav] = useState("Details");
    const [openModal, setOpenModal] = useState(false);
    const [files, setFiles] = useState([]);

    const navigate = useNavigate();
    const modalRef = useRef(null);

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setOpenModal(false);
        }
    };

    useEffect(() => {
        if (openModal) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openModal]);

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        const newPreviews = newFiles.map(file => URL.createObjectURL(file));
        setFiles(prevFiles => [...prevFiles, ...newFiles]);
    };

    const handleUpdate = async () => {
        try {
            const body = {
                agent: Fields.agent?.value,
                type: Fields.type?.value,
                priority: Fields.priority?.value,
                channel_name: Fields.channelname?.value,
            }

            await props?.updateTicket(data?.id, body);
            navigate('/ticket');
        } catch (error) {
            console.error("Error updating ticket details: ", error);
        }
    }

    const handleDelete = async () => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await props?.deleteRecord(data?.id, location.pathname)
                    Swal.fire('Deleted!', 'Your item has been deleted.', 'success');
                    navigate(-1);
                }
            });
        } catch (error) {
            console.error("Error deleting ticket: ", error);
        }
    }

    return (
        <div className='ticket-container mb-5'>
            <div className="page-title">
                <h4>Ticket#{data?.id}</h4>
                <div className="edit-btn">
                    {location.pathname === "/ticket/view" ?
                        (
                            ""
                        ) :
                        (
                            <button
                                type="submit"
                                className="custom-btn"
                                onClick={() => navigate("/ticket/view", {
                                    state: {
                                        data: {
                                            allData: data
                                        }
                                    }
                                })}

                            >
                                {/* {props.loading ? (
                                       <Spinner
                                            as="span"
                                            animation="border"
                                            className="custom-spinner"
                                            role="status"
                                            aria-hidden="true"
                                       />
                                       ) : ( */}
                                View
                                {/* )} */}
                            </button>
                        )
                    }
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >Cancel</button>
                </div>
            </div>

            <div className='row'>
                <div className="col-lg-8 col-md-8 col-sm-12 p-3">
                    <div className='TicketViewCard'>
                        {location.pathname === "/ticket/view" ?
                            (<>
                                <div>
                                    <div className='header1'>
                                        <div className='header1_p1'>
                                            <h6>
                                                {data?.subject}
                                            </h6>
                                            <p >Requested on {moment(data?.date).format('DD-MM-YYYY hh:mm A')}</p>
                                        </div>
                                        <div className='header1_p2'>
                                            <label className={`statusIndicator ${data?.status}`}></label>
                                            <label>{data?.status}</label>
                                        </div>
                                    </div>
                                    <div className='body1'>
                                        <div className='col-lg-1.5 col-md-1.5 body1_p1'>
                                            {data?.user ? (
                                                data?.user?.profile_pic ? (
                                                    <img src={`data:image/jpeg;base64,${btoa(
                                                        new Uint8Array(data.user.profile_pic.data).reduce(
                                                            (data, byte) => data + String.fromCharCode(byte),
                                                            ''
                                                        )
                                                    )}`} alt='Image' />
                                                ) : (
                                                    <UserAvatar name={data?.user?.name} size={50} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                                    // <FaUserCircle size={50} color="rgb(180, 180, 180)" />
                                                )
                                            ) : (
                                                <UserAvatar name={data?.user?.name} size={50} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                                // <FaUserCircle size={50} color="rgb(180, 180, 180)" />
                                            )}
                                        </div>
                                        <div className='col-lg-10 col-md-10 body1_p2'>
                                            <div>
                                                <h6>{data?.user?.name || data?.client?.name}</h6>
                                                <p>Requested on {moment(data?.date).format('DD-MM-YYYY hh:mm A')}</p>
                                            </div>
                                            <p dangerouslySetInnerHTML={{ __html: data?.description }}></p>
                                        </div>

                                        <div className="col-lg-0 col-md-0 body1_p3">
                                            <div className='threedots'>
                                                <BiDotsVerticalRounded onClick={() => setOpenModal(!openModal)} style={{ cursor: "pointer" }} size={20} />
                                            </div>
                                            {openModal &&
                                                (<div className="Ticket_actions_moda" ref={modalRef}>
                                                    <div className="modal-body" style={{ display: 'flex', justifyContent: 'space-between', padding: "0px" }}>
                                                        <div style={{ flexDirection: "column", alignItems: 'center', justifyContent: "center" }}>
                                                            <div className='col-lg-12' onClick={() => navigate("/ticket/view/reply", {
                                                                state: {
                                                                    data: {
                                                                        allData: data
                                                                    }
                                                                }
                                                            })} style={{ cursor: "pointer" }}>
                                                                <div>Reply</div>
                                                            </div>
                                                            <RoleWiseFeatureWrapper
                                                                modules={props?.modules}
                                                                features={props?.features}
                                                                user={props?.user}
                                                                ModuleName={ModulesList.Ticket}
                                                                Featur_Name={FeaturesList.Delete}>

                                                                <div className='col-lg-12' onClick={handleDelete} style={{ cursor: "pointer" }}>
                                                                    <div>Delete</div>
                                                                </div>
                                                            </RoleWiseFeatureWrapper>

                                                            <div className='col-lg-12' onClick={async () => {
                                                                await props.updateTicket(data?.id, { status: "Closed" });
                                                                navigate(-1);
                                                            }} style={{ cursor: "pointer" }}>
                                                                <div> Close</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )
                                            }
                                        </div>

                                    </div>
                                </div>
                                <div className=''>

                                </div>
                            </>
                            ) :
                            (
                                <ReplyTicket Fields={Fields} setFields={setFields} handleFileChange={handleFileChange} data={data} />
                            )
                        }
                    </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-12 p-3">
                    <div className='TicketViewCard'>
                        <div>

                            <div className='header2'>
                                <div>
                                    <button onClick={() => setTabNav("Details")}>Details</button>
                                    <button onClick={() => setTabNav("Contact")}>Contact</button>
                                    <button onClick={() => setTabNav("Other")}>Other</button>
                                </div>
                            </div>

                            <div className='body2'>
                                {tabnav === "Details" && (
                                    <>
                                        <div className="card-type">
                                            <label className="labeling task-catagory">
                                                <div className='input-group'>
                                                    <lable className='label'>Agent</lable>
                                                    <Select
                                                        value={Fields.agent}
                                                        onChange={(data) =>
                                                            setFields({
                                                                ...Fields,
                                                                agent: data,
                                                            }
                                                            )
                                                        }
                                                        options={agent}
                                                        placeholder={"--"}
                                                        styles={customStyle}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </label>
                                        </div>

                                        <div className="card-type">
                                            <label className="labeling task-catagory">
                                                <div className='input-group'>
                                                    <lable className='label'>Priority</lable>
                                                    <Select
                                                        value={Fields.priority}
                                                        onChange={(data) =>
                                                            setFields({
                                                                ...Fields,
                                                                priority: data,
                                                            }
                                                            )
                                                        }
                                                        options={priority}
                                                        placeholder={"--"}
                                                        styles={customStyle}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </label>
                                        </div>

                                        <div className="card-type">
                                            <label className="labeling">
                                                <div className='input-group'>
                                                    <lable className='label'>Type</lable>
                                                    <Select
                                                        value={Fields.type}
                                                        onChange={(data) =>
                                                            setFields({
                                                                ...Fields,
                                                                type: data,
                                                            }
                                                            )
                                                        }
                                                        options={type}
                                                        placeholder={"--"}
                                                        styles={customStyle}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </label>
                                        </div>

                                        <div className="card-type">
                                            <label className="labeling">
                                                <div className='input-group'>
                                                    <lable className='label'>Channel Name</lable>
                                                    <Select
                                                        value={Fields.channelname}
                                                        onChange={(data) =>
                                                            setFields({
                                                                ...Fields,
                                                                channelname: data,
                                                            }
                                                            )
                                                        }
                                                        options={channelName}
                                                        placeholder={"--"}
                                                        styles={customStyle}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </label>
                                        </div>

                                        <div className="edit-btn mt-2">
                                            <button
                                                type="submit"
                                                className="custom-btn"
                                                onClick={handleUpdate}
                                            >
                                                {/* {props.loading ? (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        className="custom-spinner"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    ) : ( */}
                                                Update
                                                {/* )} */}
                                            </button>
                                        </div>
                                    </>
                                )}
                                {tabnav === "Contact" && (
                                    <div>
                                        Contact Info
                                    </div>
                                )}
                                {tabnav === "Other" && (
                                    <div>
                                        Other Info
                                    </div>
                                )}
                            </div>
                        </div>

                        <div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.ticketReducer.loading,
        ticket: state.ticketReducer.ticket,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateTicket: (id, data) => {
            dispatch(updateTicket(id, data))
        },
        deleteRecord: (id, inputValue) => {
            dispatch(deleteRecord(id, inputValue))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TicketView)